/** Mirrors the Lovable prototype's grid (`src/pages/LcaSuppliers.tsx`): Supplier Name, Contact Name, Email, Phone, Actions. */
export const supplierTableColumnClass = {
  name: "tw-w-[28%] tw-min-w-[12rem]",
  contactName: "tw-w-[20%] tw-min-w-[9rem]",
  email: "tw-w-[24%] tw-min-w-[10rem]",
  phone: "tw-w-[18%] tw-min-w-[8rem]",
  actions: "tw-w-[10%] tw-min-w-[7rem]"
} as const;

type SupplierColumnKey = Exclude<keyof typeof supplierTableColumnClass, "actions">;

export const SUPPLIER_TABLE_COLUMNS: ReadonlyArray<{ key: SupplierColumnKey; label: string }> = [
  { key: "name", label: "Supplier Name" },
  { key: "contactName", label: "Contact Name" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" }
];
